<form [formGroup]="fmFilters" (ngSubmit)="onLoadGrid(false)" class="" autocomplete="off">
  <div class="row shadow bg-white title-list rounded mt-1">
    <div class="col-lg-12">
      <div class="row">
        <div class="{{this.classDivAux}}"></div>

        <div class="{{this.classInputSearch}}">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>{{ 'common.btnSearch' | translate }}</mat-label>
            <input formControlName="txtSearch" type="text" matInput maxlength="50" autocomplete="off"
              data-valid="notnumber">
            <button disabled="true" class="btn-serch-field"><mat-icon>search</mat-icon></button>
          </mat-form-field>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-12" [class.d-none]="!this.showDdlCompany">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>{{ 'dashboard.filters.ddlCompany' | translate }}</mat-label>
            <mat-select formControlName="ddlCompany" (selectionChange)="onChangeCompany($event)">
              <mat-option *ngFor="let item of this.catCompany" value="{{item.companyId.toString()}}">
                {{item.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-12">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>{{ 'dashboard.filters.txtBranch' | translate }}</mat-label>
            <mat-select formControlName="ddlBranch" (selectionChange)="onChangeBranch($event)">
              <mat-option *ngFor="let item of this.branches" value="{{item.id.toString()}}">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-12">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>{{ 'common.lblStatus' | translate }}</mat-label>
            <mat-select formControlName="ddlStatus">
              <mat-option *ngFor="let item of this.catStatus"
                value="{{item.id.toString()}}">{{item.description}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-12">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>{{ 'common.lblRegistrationDate' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="txtFechaAlta">
              <input matStartDate placeholder="Fecha inicio" formControlName="txtDateInit">
              <input matEndDate placeholder="Fecha fin" formControlName="txtDateEnd">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="txtFechaAlta"></mat-datepicker-toggle>
            <mat-date-range-picker #txtFechaAlta></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="col-lg-2 text-right">
          <div class="btn-group mt-2">
            <button type="button" class="btn btn-primary w-120-px mr-3" (click)="onLoadGrid(true)">
              <i class="fas fa-search text-white mr-2"></i>
              {{ 'common.btnSearch' | translate }}
            </button>

            <button tooltip="Descargar" type="button" class="btn btn-primary d-none" (click)="download()">
              <i class="fas fa-download text-white mr-2"></i></button>

            <button type="button" class="btn btn-secondary mr-2 w-100-px" (click)="removeFilter()">
              <i class="fas fa-times mr-1"></i>
              {{ 'common.btnClear' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>


  </div>
</form>


<div class="row flex pl-3 mt-3">
  <div class="emiplus_dashboard--card--total">
    <div class="emiplus_dashboard--tittle-white">
      <span>{{ 'dashboard.charts.lblTitle' | translate }}</span>
    </div>
    <div class="emiplus_dashboard--info">
      <span>{{ totalItems }}</span>
    </div>
  </div>

  <div class="emiplus_dashboard--card--status flex">
    <div class="col-4 h-100-p">
      <chart [type]="type" [data]="dataChart" [options]="options" class="chart-size"></chart>
    </div>
    <div class="col-8 h-100-p">
      <div class="row h-30-p">
        <div class="emiplus_dashboard--tittle-black fw-w-bold">
          <span>{{ 'dashboard.charts.lblTitle2' | translate }}</span>
        </div>
      </div>

      <div class="row h-30-p emiplus_dashboard--index-chart">
        <div class="col-6 flex">
          <div class="dot-circle statusExitoso"></div> {{ 'dashboard.status.success' | translate }}
        </div>
        <div class="col-6 flex">
          <div class="dot-circle statusRejected"></div> {{ 'dashboard.status.rejected' | translate }}
        </div>
      </div>

      <div class="row h-30-p emiplus_dashboard--index-chart">
        <div class="col-6 flex">
          <div class="dot-circle statusReview"></div> {{ 'dashboard.status.inReview' | translate }}
        </div>
        <div class="col-6 flex">
          <div class="dot-circle statusNa"></div> {{ 'dashboard.status.na' | translate }}
        </div>
      </div>
    </div>

  </div>

</div>

<div class="container-fluid mt-2 mb-3">

  <!-- LISTADO -->
  <div class="row pl-0 mb-3 mt-4">
    <div class="content-wrap">
      <table class="table table-custom table-hover table-sm table-grid-responsive">
        <caption></caption>
        <thead class="th-custom">
          <tr>
            <th></th>
            <th class="th-grid-responsive">
              {{ 'dashboard.gridColumns.IdOperation' | translate }}
              <fa-icon *ngIf="ordened == 0" [icon]="Icon_Down" style="cursor: pointer; display: contents;" (click)="order(1)"
                class="emiplus-table--iconDown"></fa-icon>
              <fa-icon *ngIf="ordened == 1" [icon]="Icon_Up" style="cursor: pointer; display: contents;" (click)="order(1)"
                class="emiplus-table--iconDown"></fa-icon>
            </th>
            <th class="th-grid-responsive">{{ 'dashboard.gridColumns.FatherName' | translate }}</th>
            <th class="th-grid-responsive">{{ 'dashboard.gridColumns.MotherName' | translate }}</th>
            <th class="th-grid-responsive">{{ 'dashboard.gridColumns.Name' | translate }}</th>
            <th class="th-grid-responsive">{{ 'dashboard.gridColumns.RegistrationDate' | translate }}</th>
            <th class="th-grid-responsive">{{ 'dashboard.gridColumns.BranchKey' | translate }}</th>
            <th class="th-grid-responsive">{{ 'dashboard.gridColumns.BranchName' | translate }}</th>
            <th class="th-grid-responsive">{{ 'dashboard.gridColumns.Status' | translate }}</th>
            <th class="th-grid-responsive">{{ 'dashboard.gridColumns.transaction' | translate }}</th>
            <th class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let data of dataInformation">
            <tr class="tr-custom">
              <td [ngClass]="{
                  'statusExitoso': (data.status == 1 || data.successManual),
                  'statusReview': (data.status == 2 && !data.successManual),
                  'statusRejected': (data.status == 3 && !data.successManual),
                  'statusNa': (data.status == 0 && !data.successManual)
                  }">
              </td>
              <td class="td-grid-responsive w-5-p">
                <span class="th-name-col">Folio</span>
                <span class="td-value-row"> {{ data.id }} </span>
              </td>
              <td class="td-grid-responsive w-10-p">
                <span class="th-name-col">fatherSurname</span>
                <span class="td-value-row"> {{ data.fatherSurname }} </span>
              </td>
              <td class="td-grid-responsive w-10-p">
                <span class="th-name-col">motherSurname</span>
                <span class="td-value-row"> {{ data.motherSurname }} </span>
              </td>
              <td class="td-grid-responsive w-15-p">
                <span class="th-name-col">firstName</span>
                <span class="td-value-row"> {{ data.firstName }} </span>
              </td>
              <td class="td-grid-responsive w-10-p">
                <span class="th-name-col">registrationDate</span>
                <span class="td-value-row"> {{ data.registrationDate }}</span>
              </td>
              <td class="td-grid-responsive w-5-p">
                <span class="th-name-col">registrationDate</span>
                <span class="td-value-row"> {{ data.branch.key }}</span>
              </td>
              <td class="td-grid-responsive w-5-p">
                <span class="th-name-col">registrationDate</span>
                <span class="td-value-row"> {{ data.branch.alias }}</span>
              </td>
              <td class="td-grid-responsive w-10-p">
                <span class="th-name-col">Estatus</span>
                <span class="td-value-row" *ngIf="data.status == 1 || data.successManual">
                  {{ 'dashboard.catStatus.Success' | translate }}
                </span>
                <span class="td-value-row" *ngIf="data.status == 2 && !data.successManual ">
                  {{ 'dashboard.catStatus.InReview' | translate }}
                </span>
                <span class="td-value-row" *ngIf="data.status == 3 && !data.successManual ">
                  {{ 'dashboard.catStatus.Reject' | translate }}
                </span>
                <span class="td-value-row" *ngIf="data.status == 0 && !data.successManual ">
                  {{ 'dashboard.catStatus.NA' | translate }}
                </span>
              </td>
              <td class="td-grid-responsive w-20-p" tooltip="{{data.transactionId}} - {{data.transactionName}}">
                <div class="text-finaly-3-points">
                  {{data.transactionId}} - {{data.transactionName}}
                </div>
              </td>
              <td class="text-center td-content-btn td-grid-responsive w-10-p">
                <button tooltip="{{ 'dashboard.gridColumns.ViewDetails' | translate }}" type="button"
                  class="btn-none m-0-px" (click)="information(data.id, data.transactionId, data.branchId)">
                  <i class="fa-solid fa-eye emi-font-secondary"></i>
                </button>
                <button tooltip="{{ 'dashboard.gridColumns.ViewExpedient' | translate }}" type="button"
                  class="btn-none m-0-px" (click)="expedient(data.id, data.transactionId, data.branchId)">
                  <i class="fa-solid fa-file-lines emi-font-secondary"></i>
                </button>

                <ng-container *ngIf="showBtnDelete">
                  <button tooltip="{{ 'dashboard.gridColumns.deleteEnrollment' | translate }}" type="button"
                    class="btn-none m-0-px" (click)="delete(data.id)">
                    <i class="fa-solid fa-trash emi-font-secondary"></i>
                  </button>
                </ng-container>

                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="more_vert"
                  class="m-0-px h-30-px w-30-px">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <ng-container *ngIf="showItemExpedient">
                    <button mat-menu-item (click)="getExpedientS(data.externalClientId)">
                      <span>{{ 'dashboard.gridColumns.lblExpedient' | translate }}</span>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="showItemContract">
                    <button mat-menu-item (click)="getFileDocument(data.externalClientId, 'CONTRACT')">
                      <span>{{ 'dashboard.gridColumns.lblContract' | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="getASN1(data.externalClientId, data.signedPdf, 'CONTRACT')"
                      [disabled]="!data.signedPdf">
                      <span>{{ 'dashboard.gridColumns.lblContractASN1' | translate }}</span>
                    </button>
                  </ng-container>

                  <button mat-menu-item (click)="getFileDocument(data.externalClientId, 'ADVICE')">
                    <span>{{ 'dashboard.gridColumns.lblNoticePrivacy' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="getASN1(data.externalClientId, data.signedPdf, 'ADVICE')">
                    <span>{{ 'dashboard.gridColumns.lblNoticePrivacyASN1' | translate }}</span>
                  </button>

                  <ng-container *ngIf="data.hasConfirmation && showItemManualValidation">
                    <button mat-menu-item (click)="openManualValidation(data.externalClientId)"
                      [disabled]="data.successManual || data.status == 1">
                      <span>{{ 'dashboard.gridColumns.lblManualValidation' | translate }}</span>
                    </button>
                  </ng-container>

                </mat-menu>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="this.emptyDataList && this.IsPostBack" class="grid-empty text-center bg-light">
            <td colspan="12" class="mt-3 h-360-px justify-all-center">
              <img class="img-folder-empty" src="assets/images/icon/Folder.svg" alt="empty folder">
              <br>
              <span class="text-info-gray">{{ msgDataEmpty }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row mr-3">
    <div class="col-md-12 mb-5 d-flex justify-content-end">
      <app-pagination-table [totalPages]="totalPages" [currentPage]="currentPage"
        (changePage)="changePage($event)"></app-pagination-table>
    </div>
  </div>

</div>

<ng-container *ngIf="showModalDialogManualValid">
  <app-successful-manual-acceptance [idClient]="idClientManualValid"
    (displayChangeSuccessManual)="closeManualValidation($event)"></app-successful-manual-acceptance>
</ng-container>